import _ from "lodash";
import ApiClient from "../ApiClient";
import { getProductData } from "../Product/ProductService/productService";
import { apiPatch } from "../Api/apiCall";
import { getUpdateData, persistCustomer, persistPerson } from "./persisterService";
import { CaseInsurance } from "../../types/CaseInsurance";
import { ProductUnion } from "../../types/ProductUnion";
import { UseForm } from "../../types/UseForm";

export const persistDocument = async (updateData: UseForm["values"], origDocument: ProductUnion) => {
  if (_.isObject(updateData.customer)) {
    const customerUpdateData = getUpdateData(updateData.customer, origDocument, "customer");
    await persistCustomer(origDocument.customer.id, customerUpdateData);
  }
  if (_.isObject(updateData.petitioner)) {
    const petitionerUpdateData = getUpdateData(updateData.petitioner, origDocument, "petitioner");
    await persistPerson(origDocument.petitioner.id, petitionerUpdateData);
  }
  if (_.has(updateData, "caseInsurance") && _.isObject(updateData.caseInsurance)) {
    let caseInsuranceUpdateData = getUpdateData(updateData.caseInsurance, origDocument, "caseInsurance");

    const caseInsurance: Partial<CaseInsurance> = updateData.caseInsurance;
    caseInsuranceUpdateData.insurer = caseInsurance.insurer?.id
      ? "/insurers/" + caseInsurance.insurer.id
      : origDocument.caseInsurance.insurer?.["@id"];

    await ApiClient.patch(`case_insurances/${origDocument.caseInsurance.id}`, {
      body: JSON.stringify(caseInsuranceUpdateData),
    });
  }

  if (_.has(updateData, "caseInsurance.policyHolder") && _.isObject(updateData.caseInsurance.policyHolder)) {
    const policyHolderUpdateData = getUpdateData(
      updateData.caseInsurance.policyHolder,
      origDocument,
      "caseInsurance.policyHolder"
    );
    await persistPerson(origDocument.caseInsurance.policyHolder.id, policyHolderUpdateData);
  }
  const apiUri = getProductData(origDocument.productClassName, "apiUri");
  const documentUpdateData = getUpdateData(updateData, origDocument);
  await apiPatch(apiUri, origDocument.id, documentUpdateData);
};
